const resetPasswordModalStyle = Object.freeze({
  buttonVariant: 'secondary',
});

export default resetPasswordModalStyle;
